<div class="products-list-page p-4 md:p-6 lg:p-8">
  <!-- Header Section -->
  <div class="mb-8">
    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div>
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Gestión de Productos</h1>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Administra el catálogo de productos y sus comisiones.
        </p>
      </div>

      <div class="flex items-center gap-3">
        <a
          routerLink="/admin/products/new"
          class="inline-flex items-center gap-2 px-4 py-2 bg-brand-red hover:bg-brand-red/90 text-white text-sm font-semibold rounded-lg transition-all shadow-sm shadow-brand-red/20 active:scale-95"
        >
          <fa-icon [icon]="faPlus"></fa-icon>
          <span>Nuevo Producto</span>
        </a>
      </div>
    </div>
  </div>

  <!-- Search and Filters -->
  <div class="toolbar mb-6">
    <div class="relative flex-1 max-w-md">
      <fa-icon
        [icon]="faMagnifyingGlass"
        class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"
      ></fa-icon>
      <input
        #searchInput
        type="text"
        placeholder="Buscar por nombre..."
        (input)="onSearch(searchInput.value)"
        class="w-full pl-10 pr-4 py-2 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg text-sm focus:ring-2 focus:ring-brand-red/20 focus:border-brand-red outline-none transition-all dark:text-gray-200"
      />
    </div>
  </div>

  <!-- Error Message -->
  @if (error) {
    <div
      class="error-message mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg text-red-600 dark:text-red-400 text-sm flex items-center gap-3"
    >
      <fa-icon icon="circle-exclamation"></fa-icon>
      {{ error }}
    </div>
  }

  <!-- Products Table -->
  <div
    class="users-table-wrapper shadow-sm border border-gray-200 dark:border-gray-800 rounded-xl bg-white dark:bg-gray-900 overflow-hidden"
  >
    <table class="users-table w-full text-left border-collapse">
      <thead>
        <tr class="bg-gray-50 dark:bg-gray-800/50">
          <th (click)="onSort('name')" class="sortable">
            <div class="header-content">
              Nombre
              <fa-icon
                [icon]="getSortIcon('name')"
                class="sort-icon"
                [class.active]="sortBy === 'name'"
              ></fa-icon>
            </div>
          </th>
          <th (click)="onSort('category')" class="sortable">
            <div class="header-content">
              Categoría
              <fa-icon
                [icon]="getSortIcon('category')"
                class="sort-icon"
                [class.active]="sortBy === 'category'"
              ></fa-icon>
            </div>
          </th>
          <th>Valor Estimado</th>
          <th (click)="onSort('commission')" class="sortable">
            <div class="header-content">
              Comisión
              <fa-icon
                [icon]="getSortIcon('commission')"
                class="sort-icon"
                [class.active]="sortBy === 'commission'"
              ></fa-icon>
            </div>
          </th>
          <th (click)="onSort('updated_at')" class="sortable">
            <div class="header-content">
              Última actualización
              <fa-icon
                [icon]="getSortIcon('updated_at')"
                class="sort-icon"
                [class.active]="sortBy === 'updated_at'"
              ></fa-icon>
            </div>
          </th>
          <th class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        @if (isLoading) {
          <tr>
            <td colspan="6" class="py-12 text-center">
              <div class="flex flex-col items-center gap-3">
                <div
                  class="w-8 h-8 border-2 border-brand-red border-t-transparent rounded-full animate-spin"
                ></div>
                <span class="text-sm text-gray-500 dark:text-gray-400">Cargando productos...</span>
              </div>
            </td>
          </tr>
        } @else if (filteredProducts.length === 0) {
          <tr>
            <td colspan="6" class="py-12 text-center">
              <div class="empty-state">
                <fa-icon
                  [icon]="faBox"
                  class="text-4xl text-gray-300 dark:text-gray-700 mb-3"
                ></fa-icon>
                <h3 class="text-base font-semibold text-gray-900 dark:text-white">
                  No se encontraron productos
                </h3>
                <p class="text-sm text-gray-500 dark:text-gray-400">
                  Prueba con otros términos de búsqueda o crea uno nuevo.
                </p>
              </div>
            </td>
          </tr>
        } @else {
          @for (product of filteredProducts; track product.id) {
            <tr class="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors">
              <td class="font-medium text-gray-900 dark:text-white">
                <div class="flex flex-col">
                  <span>{{ product.name }}</span>
                  <span
                    class="text-[10px] text-gray-400 dark:text-gray-500 line-clamp-1"
                    [title]="product.description"
                  >
                    {{ product.description }}
                  </span>
                </div>
              </td>
              <td class="text-sm text-gray-600 dark:text-gray-300">
                {{ product.category }}
              </td>
              <td class="text-sm font-medium text-gray-700 dark:text-gray-200">
                {{ product.estimated_value }}
              </td>
              <td>
                <span
                  class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 font-semibold text-xs"
                >
                  {{ product.commission }}%
                </span>
              </td>
              <td class="text-sm text-gray-500 dark:text-gray-400">
                {{ product.updated_at | date: 'dd/MM/yyyy HH:mm' }}
              </td>
              <td class="text-right">
                <div class="actions-menu-wrapper">
                  <button
                    type="button"
                    (click)="toggleMenu(product.id, $event)"
                    class="btn-actions p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                  >
                    <fa-icon [icon]="faEllipsisVertical"></fa-icon>
                  </button>

                  @if (openMenuId === product.id && menuPosition) {
                    <div
                      class="dropdown-menu fixed w-48 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-xl z-50 py-1 overflow-hidden"
                      [style.top.px]="menuPosition.top"
                      [style.left.px]="menuPosition.left"
                      (click)="$event.stopPropagation()"
                    >
                      <a
                        [routerLink]="['/admin/products', product.id]"
                        class="dropdown-item flex items-center gap-3 px-4 py-2 text-sm text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                        (click)="closeMenu()"
                      >
                        <fa-icon [icon]="faPen" class="text-gray-400"></fa-icon>
                        Editar producto
                      </a>
                      <button
                        type="button"
                        class="dropdown-item danger flex items-center gap-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors w-full text-left"
                        (click)="deleteProduct(product.id); closeMenu()"
                      >
                        <fa-icon [icon]="faTrash" class="text-red-400"></fa-icon>
                        Eliminar producto
                      </button>
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</div>
